<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <WorkPlanShiftForm
      v-if="!isLoading"
      :workPlanDayData="workPlanDayData"
      :submitName="$t('edit')"
      v-on:updateWorkPlanShifts="updateWorkPlanShifts"
    />
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import { STATUS } from "@/utils/constants";
import WorkPlanShiftForm from "@/components/settings/settingsSalary/workPlanDays/WorkPlanShiftForm.vue";
import WorkPlanDay from "@/models/settings/settingsSalary/workPlanDays/WorkPlanDay";
import createToastMixin from "@/utils/create-toast-mixin";

export default {
  name: "WorkPlanShiftsEdit",
  mixins: [createToastMixin],
  components: {
    PreLoader,
    ExceptionWithImg,
    WorkPlanShiftForm,
  },
  data() {
    return {
      isLoading: true,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      workPlanDayData: new WorkPlanDay(),
      workPlanDayToken: this.$route.params.workPlanDayToken,
    };
  },
  methods: {
    async getWorkPlanDayDetails() {
      this.isLoading = true;
      this.workPlanDayData.workPlanDayToken = this.workPlanDayToken;
      try {
        let response = await this.workPlanDayData.getWorkPlanDayDetails(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.workPlanDayData.fillData(response.data.workPlanData);
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
          this.workPlanDayData = null;
        }
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.workPlanDayData = null;
      }
      this.isLoading = false;
    },
    async updateWorkPlanShifts() {
      this.isLoading = true;
      try {
        let response = await this.workPlanDayData.updateWorkPlanShifts(
          this.language,
          this.userAuthorizeToken
        );
        if (response.data.status == STATUS.SUCCESS) {
          this.showMsg(response.data.msg, true);
          this.$router.push(
            `/work-plan-days/${this.workPlanDayData.workPlanToken}`
          );
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.showMsg(response.data.msg);
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        } else {
          this.showMsg(response.data.msg);
        }
      } catch (e) {
        this.showMsg(this.$t("errorCatch"));
      }
      this.isLoading = false;
    },
  },
  async created() {
    this.getWorkPlanDayDetails();
  },
};
</script>
